<template lang="pug">
  section.banner.wrapper-p
    .banner__img
      base-picture(
        :minScreenWidth="picture.minScreenWidth"
        :desktopName="picture.desktopName"
        :mobileName="picture.mobileName"
        :alt="picture.alt"
      )

    .banner__content
      h1.banner__title.clr-white.t-h1 Новый подход к бортовому оборудованию
      .banner__text.clr-white
        p Комплексное интеллектуальное решение для управления транспортом на основе специализированного компьютера (ЦБК) с программным обеспечением «Встраиваемый программный комплекс реализующий информационно-коммуникационные и навигационные функции на борту общественных пассажирских транспортных средств» собственной разработки.
        p ЦБК поставляется заказчику готовом для применения и конфигурирования виде (в зависимости от требований заказчика).
        p Стоимость решения рассчитывается индивидуально, исходя из функциональных требований заказчика. Для расчета стоимости, пожалуйста, воспользуйтесь формой

      base-button(
        :btnClass="button.btnClass"
        :btnType="button.btnType"
        :btnText="button.btnText"
        :btnStyle="button.btnStyle"
        @click.native.stop="orderBtnClick"
      )

    a.banner__modal-btn.js-modal-btn(
      href=`https://www.youtube.com/watch?v=I-s0gVy-X7g`
      target=`_blank`
      @click.prevent="videoBtnClick"
    )
      svg.banner__modal-icon.banner__modal-icon--dashed.clr-l-blue(
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 120 120'
        fill="none"
      )
        ellipse(
          stroke='currentColor'
          stroke-width='2.5'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-dasharray='3, 6'
          cx='60' cy='60'
          rx='60' ry='60')

        use(:href="$setSvgHref(`img/sprite.svg#i-dashed-circle`)")
      base-picture(
        :minScreenWidth="modalBtn.minScreenWidth"
        :desktopName="modalBtn.desktopName"
        :mobileName="modalBtn.mobileName"
        :alt="modalBtn.alt"
      )

      svg.banner__modal-icon.banner__modal-icon--play.clr-white(xmlns=`http://www.w3.org/2000/svg`)
        use(:href="$setSvgHref(`img/sprite.svg#i-play`)")

    transition(name="fade")
      .banner__modal-video(
        v-if="videoVisible"
      )
        button.banner__modal-close-btn-big(
          @click.prevent="videoModalCloseBtnClick"
        ) Закрыть окно
        .banner__modal-video-content.bg-white
          button.banner__modal-close-btn(
            @click.prevent="videoModalCloseBtnClick"
          ) Закрыть окно
          iframe(width='560', height='315', src='https://www.youtube.com/embed/I-s0gVy-X7g', frameborder='0', allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', allowfullscreen='')

</template>

<script>
export default {
  data () {
    return {
      picture: {
        minScreenWidth: `1024px`,
        desktopName: `banner-desktop`,
        mobileName: `banner-desktop`,
        alt: `Новый подход к бортовому оборудованию`
      },
      button: {
        btnClass: `btn--fill`,
        btnText: `Получить коммерческое предложение`,
        btnStyle: {
          color: `#5182dd`
        }
      },
      modalBtn: {
        minScreenWidth: `1024px`,
        desktopName: `banner-modal-image`,
        mobileName: `banner-modal-image`,
        alt: `Открыть видео`
      }
    }
  },
  computed: {
    videoVisible () {
      return this.$store.getters.videoVisible
    }
  },
  methods: {
    orderBtnClick () {
      this.$store.dispatch(`showModal`, {
        title: `Заявка`,
        visible: true
      })
    },
    videoBtnClick () {
      if (this.videoVisible) {
        this.$store.dispatch(`hideVideoModal`)
      } else {
        this.$store.dispatch(`showVideoModal`)
      }
    },
    videoModalCloseBtnClick () {
      this.$store.dispatch(`hideVideoModal`)
    }
  }
}
</script>

<style lang="scss" scoped>
  .banner {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-height: 100vh;
    padding-top: var(--header-height);
    padding-bottom: 8.125vw;

    @include respond-max(tablet) {
      padding-bottom: 4rem;
    }
  }

  .banner__img {
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #162050;
  }

  .banner__content {
    display: flex;
    flex-direction: column;
  }

  .banner__title {
    max-width: 820px;
    margin-top: 0;
    margin-bottom: 3.4rem;
  }

  .banner__text {
    max-width: 712px;
    margin-top: 0;
    margin-bottom: 3.625rem;
    font-size: 1.4rem;

    @include respond-max(tablet) {
      font-size: 1.2rem;
    }

    p:not(:first-child) {
      margin-top: 1.6rem;
    }
  }

  .banner__modal-btn {
    overflow: hidden;
    position: absolute;
    bottom: 8.125vw;
    right: $offset-desktop;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 6.25vw;
    height: 6.25vw;
    border-radius: 50%;

    picture {
      overflow: hidden;
      width: 90%;
      height: 90%;
      border-radius: 50%;
    }

    &:hover {
      /deep/ .picture__img {
        transform: scale(1.1);
      }
    }

    @include respond-max(tablet) {
      bottom: 4rem;
      width: 5rem;
      height: 5rem;
    }

    @include respond-max(mobile-md) {
      bottom: 10rem;
    }
  }

  .banner__modal-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &--dashed {
      width: 100%;
      height: 100%;
      animation: spin 30s linear infinite;

      ellipse {
        transition: $trs;
      }

      @keyframes spin {
        from {
          transform: translate(-50%, -50%) rotate(0deg);
        }
        to {
          transform: translate(-50%, -50%) rotate(360deg);
        }
      }
    }

    &--play {
      width: 30%;
      height: 30%;
      transform: translate(calc(-36%), -50%);
      transition: $trs;
    }
  }

  .banner__modal-video {
    overflow: auto;
    position: fixed;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    transition: $trs;

    iframe {
      width: 100%;
      height: 100%;
    }
  }

  .banner__modal-close-btn-big {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    background-color: $grey;
    opacity: 0.5;
  }

  .banner__modal-video-content {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    width: 60vw;
    height: 70vh;
    padding-top: 4rem;
    padding-bottom: 3.5rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    border-radius: 1.5rem;
    box-shadow: 0px 16px 16px rgba(26, 32, 59, 0.16);
    transform: translate(-50%, -50%);

    @include respond-max(tablet) {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      border-radius: 0;
      transform: none;
      box-shadow: none;
    }
  }

  .banner__modal-close-btn {
    position: absolute;
    top: 0.875rem;
    right: 0.875rem;
    width: 2.125rem;
    height: 2.125rem;
    padding: 0.5rem;
    font-size: 0;
    border: 0;
    background-color: transparent;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1px;
      height: 1.125rem;
      background-color: $black;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
</style>
